import React, { type FC, type ReactNode, useMemo } from 'react';
import { ConfluenceExperimentsContext } from '@post-office/growth-common/confluence-experiments-context';

import EmojiResource from '@atlaskit/emoji/emoji-resource';

import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';
import { getEmojiProvider } from '@confluence/fabric-providers/entry-points/EmojiProvider.ts';
import { getPageDataFromUrl } from './hooks/getPageDataFromUrl.ts';
import { usePageRecommendationData } from './hooks/usePageRecommendationData.tsx';
import { useInlineReactionsData } from './hooks/useInlineReactionsData.ts';
import { useCurrentPageTemplateData } from './hooks/useCurrentPageTemplateData.ts';

export const ConfluenceExperimentsProvider: FC<{ children: ReactNode }> = ({ children }) => {
	const { userId, cloudId } = useSessionData();
	const templateXflow = useCurrentPageTemplateData();

	const experimentsContextValue = useMemo(() => {
		return {
			templateXflow,
			usePageRecommendationData,
			useInlineReactionsData,
			getPageDataFromUrl,
			emojiProvider: getEmojiProvider(EmojiResource, {
				userId,
				cloudId,
			}),
		};
	}, [userId, cloudId, templateXflow]);

	return (
		<ConfluenceExperimentsContext.Provider value={experimentsContextValue}>
			{children}
		</ConfluenceExperimentsContext.Provider>
	);
};
